import _swal from "sweetalert2";
import {UYAP_ENGEL_KAPISI_MESAJI} from "@/plugins/uyap-plugin/UyapEngeli";

/**
 * UYAP insan doğrulaması engeli: panel metinleri ve saf yardımcılar (DEV-3572).
 *
 * Kullanıcıya görünen her metin TEK yerde (SOZLESME §8.1, K8): değişiklik yalnız buradadır ve
 * metinleri literal karşılaştıran testler (`tests/unit/utils/uyapEngel.spec.ts`) birlikte değişir.
 * Bu modül `@/main`, store ve DOM import ETMEZ.
 */
export const UYAP_ENGEL_METINLERI = {
    bildirimBaslik: "UYAP insan doğrulaması istedi",
    bildirimGovde: "İşlemler durduruldu; bekleyen dosyalar sırada.",
    pencereBaslik: "UYAP insan doğrulaması istedi; işlemler durduruldu",
    pencereAciklama: "Bu nedenle UYAP'a istek göndermeyi bıraktık; bekleyen işler sırada duruyor.",
    anladim: "Anladım",
    uyapiAc: "UYAP'ı aç",
    izinVer: "Yeniden denemeye izin ver",
    seritPanel: "Panel: Bu ekrandaki istek UYAP engeline takıldı",
    seritBot: "Bot: UYAP engeli nedeniyle durdu",
    seritOrtak: "UYAP'a istek göndermeyi bıraktık; bekleyen işler sırada duruyor.",
    onayBaslik: "Yeniden denensin mi?",
    onayMetin: "UYAP uyarısı sürüyorsa bot ilk dosyada yeniden durur ve o dosya hatalı biter.",
    onayDene: "Dene",
    onayVazgec: "Vazgeç",
    kapiToast: UYAP_ENGEL_KAPISI_MESAJI,
    // K8 dışı mekanik metin (SOZLESME §8.2)
    duraklatildiIpucu: "Duraklatıldı. UYAP engeli sürüyor."
};

/** UYAP'ın metni güvenilmez veridir: yalnız düz metin (Vue enterpolasyonu / swal text), 300 karakter. */
const EN_FAZLA_ENGEL_METNI = 300;

export function uyapEngeliMetniniSuz(ham: any): string {
    if (typeof ham !== "string") return "";
    return ham.replace(/\s+/g, " ").trim().slice(0, EN_FAZLA_ENGEL_METNI);
}

function ikiHane(sayi: number): string {
    return sayi < 10 ? "0" + sayi : String(sayi);
}

/** 'HH:MM' (yerel saat). toLocaleTimeString KULLANILMAZ: node small-icu'da 'tr-TR' bozuk, test kırılgan olur. */
export function engelSaati(zaman: any): string {
    if (typeof zaman !== "number" || !isFinite(zaman) || zaman <= 0) return "";
    const t = new Date(zaman);
    return ikiHane(t.getHours()) + ":" + ikiHane(t.getMinutes());
}

export interface EngelKaydiGorunumu {
    zaman: number;
    metin: string;
}

export interface EngelSeridiSatiri {
    anahtar: string;
    metin: string;
}

/** Şerit satırları: önce Panel, sonra (yalnız biliniyorsa) Bot. Saat bilinmiyorsa " · HH:MM" eklenmez. */
export function engelSeridiSatirlari(girdi: { panel: EngelKaydiGorunumu | null, imzaci: EngelKaydiGorunumu | null }): EngelSeridiSatiri[] {
    const satirlar: EngelSeridiSatiri[] = [];
    const saatEki = (kayit: EngelKaydiGorunumu): string => {
        const saat = engelSaati(kayit.zaman);
        return saat ? " · " + saat : "";
    };
    if (girdi.panel) satirlar.push({anahtar: "panel", metin: UYAP_ENGEL_METINLERI.seritPanel + saatEki(girdi.panel)});
    if (girdi.imzaci) satirlar.push({anahtar: "bot", metin: UYAP_ENGEL_METINLERI.seritBot + saatEki(girdi.imzaci)});
    return satirlar;
}

/**
 * Soket 'notification' yükü imzacının engel duyurusu mu? İmzacı yükü (SOZLESME §6):
 * `{message: 'Bot: UYAP engeli nedeniyle durdu · HH:MM', seconds: 8, uyapEngeli: {zaman}}`.
 * İşaretliyse `{aktif: true, zaman}` döner (panel çarklı "Cevap bekleniyor" toast'ı YERİNE Bot satırı kurar);
 * işaretsiz bildirim null. Alan yalnız `typeof ham.uyapEngeli === 'object'` ile tanınır; `message` OKUNMAZ
 * (Bot satırı metnini panel kendi sabitinden + `zaman`'dan üretir); `zaman` yoksa `Date.now()`.
 */
export function imzaciEngelBildirimi(ham: any): { aktif: boolean, zaman: number } | null {
    if (!ham || typeof ham !== "object" || !ham.uyapEngeli || typeof ham.uyapEngeli !== "object") return null;
    const zaman = ham.uyapEngeli.zaman;
    return {aktif: true, zaman: typeof zaman === "number" && isFinite(zaman) && zaman > 0 ? zaman : Date.now()};
}

/**
 * K8 "Başlat onayı" (K5): YALNIZ Başlat'ta kullanılır; şerit/pencere "Yeniden denemeye izin ver" ONAYSIZdır
 * (SOZLESME §13.7, B-2). `goster` testte enjekte edilir (buroDegistirme.ts deseni).
 */
export async function yenidenDenemeOnayi(goster?: (secenek: any) => Promise<any>): Promise<boolean> {
    const sonuc = await (goster || ((secenek: any) => _swal.fire(secenek)))({
        icon: "warning",
        title: UYAP_ENGEL_METINLERI.onayBaslik,
        text: UYAP_ENGEL_METINLERI.onayMetin,
        showCancelButton: true,
        confirmButtonText: UYAP_ENGEL_METINLERI.onayDene,
        cancelButtonText: UYAP_ENGEL_METINLERI.onayVazgec,
        reverseButtons: true
    });
    return !!(sonuc && sonuc.isConfirmed);
}
